import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AbstractService } from '../../../../core/common/service/AbstractService';

/**
 * Loginパスワード再設定依頼画面のServiceクラス
 * @author GAUSS
 * @since 1.0.0
 *
 * 履歴：
 * NO 日付        更新者        内容
 *  1 2018/06/21 T.Utsunomiya   新規作成
 */
@Injectable()
export class DevtoolIndexService extends AbstractService {
  constructor(private  httpClient:  HttpClient) {
    super();
  }

  public create(url) {
    return this.httpClient.post(`${this.API_URL}/kube/deployments`, { url });
  }
}